<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <alerts></alerts>
            <BodiesListTable
                v-bind="$attrs"
                :route="routes"
            ></BodiesListTable>
        </div>
    </div>
</template>

<script>
import BodiesListTable from './BodiesListTable';

export default {
    components: {
        BodiesListTable,
    },
    data: function () {
        return {
            alertData: {},
            routes: {
                category: this.$route.path + '/categories/:id:',
                show: this.$route.path + '/:id:',
                edit: this.$route.path + '/:id:/edit',
                deactivate: '/predefined-bodies/:id:/active/0',
                active: '/predefined-bodies/:id:/active/1',
                create: '/predefined-bodies/new',
            },
        };
    },
};
</script>
